/* Static statistics related to creators */
export const STATIC_STATISTICS_CREATOR = {
  COUNT: 50000,
};
